export const NotificationAdminFilterKey = {
  Type: 'type',
  Read: 'read',
} as const;
export type NotificationAdminFilterKey =
  (typeof NotificationAdminFilterKey)[keyof typeof NotificationAdminFilterKey];
export const NOTIFICATION_ADMIN_FILTER_KEYS = [
  NotificationAdminFilterKey.Type,
  NotificationAdminFilterKey.Read,
] as const;
